import React from 'react';
import Select from 'react-select';
import { Roles } from '../constants/constants';
import styles from '../template/outerlayout/outerlayout.module.css';

function Onboarding() {
    return (
        <form className={styles.welcomeForm}>
            <div className={styles.fieldWrapper}>
                <div>
                    <label>Hi! I’m A</label>
                </div>
                <div className={styles.field}>
                    <Select placeholder="Select a role" options={Roles} className={styles.customSelect} />
                </div>
            </div>
        </form>
    );
}

export default Onboarding;
